import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './Banner.css';

const CounterSection = () => {

    const [counter, setCounter] = useState([]);
    const [page, setPage] = useState([]);
    const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/counters`)
            .then((res) => res.json())
            .then((info) => setCounter(info));
    }, []);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
            .then((res) => res.json())
            .then((info) => setPage(info))
            .catch((error) => console.error("Error fetching banners:", error));
    }, []);



    return (


        <>
            {
                counter.map(b => b.pageSlug === page.pageSlug && <section className="statistics-section" id="statistics">
                    <div className="container">
                        <figure className="mb-0 statistics-sidelayer">
                            <img src="./assets/images/statistics-sidelayer.png" alt />
                        </figure>
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="statistics_content">
                                </div>
                            </div>
                        </div>
                        <div className="statistics-value" data-aos="fade-down">
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                                    <div className="number1">
                                        <span className="value1 counter">{b.projectCompleteNumber}</span>
                                        <sup className="mb-0 plus">+</sup>
                                        <span className="text1">{b.projectCompleteText}</span>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                                    <div className="number1">
                                        <span className="value1 counter">{b.happyClientsNumber}</span>
                                        <sup className="mb-0 plus">+</sup>
                                        <span className="text1 text2">{b.happyClientsText}</span>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                                    <div className="number1">
                                        <span className="value1 counter">{b.teamNumber}</span>
                                        <sup className="mb-0 plus">+</sup>
                                        <span className="mb-0 text1 text3">{b.teamText}</span>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                                    <div className="number1 number4">
                                        <span className="value1 counter">{b.yearofExperienceNumber}</span>
                                        <sup className="mb-0 plus">+</sup>
                                        <span className="mb-0 text1 text4">{b.yearofExperienceText}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>)}
        </>
    );
};

export default CounterSection;
